var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.315 13.7841C18.0293 13.7841 16.7669 13.583 15.5706 13.1877C14.9844 12.9877 14.2638 13.1712 13.906 13.5386L11.5448 15.3211C8.80638 13.8593 7.1196 12.1731 5.67782 9.45531L7.40786 7.15559C7.85734 6.70671 8.01855 6.05101 7.8254 5.43577C7.42837 4.2332 7.22668 2.97139 7.22668 1.68514C7.22673 0.755945 6.47079 0 5.54165 0H1.68509C0.755945 0 0 0.755945 0 1.68509C0 12.3355 8.66458 21 19.315 21C20.2441 21 21.0001 20.2441 21.0001 19.3149V15.4691C21 14.54 20.2441 13.7841 19.315 13.7841Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneAssistance);
export default __webpack_public_path__ + "static/media/icon-phone-assistance.c8e4eb92f1d268af54c8dbca4532fdb7.svg";
export { ForwardRef as ReactComponent };